export const AuthApiEndpoint = {
  updateId: '/users/web-id', // 아이디 변경
};
